import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { tap, take, map } from 'rxjs/operators';
import {
  LoadHolidaysAction,
  LoadHolidaysCompleteAction,
  LoadHolidaysActionTypes,
} from '../actions/load-holidays.actions';
import { Store, createSelector, Action } from '@ngrx/store';
import { LOAD_CONFIG_COMPLETE } from '../../../../modules/specification/actions/specification.actions';
import { HolidaysState } from '../../../../modules/specification/reducers/specification/load-holidays.reducer';
import { getLegalEntity } from '@cemex/cmx-client-layout';
import * as moment from 'moment';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { LoadHolidaysRequest } from '@cemex-core/cmx-api/models/holidays/holidays-req';
import { HolidaysService } from '@cemex-core/cmx-api';

const getRequestData = createSelector(getLegalEntity, (customer) => {
  return customer;
});

// Response: Date[]
@Injectable()
export class LoadHolidaysEffect {
  loadConfig: Observable<Action> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LOAD_CONFIG_COMPLETE),
        tap((action) => {
          this.store
            .select(getRequestData)
            .pipe(
              take(1),
              map((customer) => {
                return {
                  countryCode: customer.countryCode,
                };
              }),
            )
            .subscribe((request: LoadHolidaysRequest) => this.holidaysStore.dispatch(new LoadHolidaysAction(request)));
        }),
      ),
    { dispatch: false },
  );

  loadHolidays: Observable<Action> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoadHolidaysActionTypes.LOAD),
        tap((action: LoadHolidaysAction) => {
          this.holidaysService.getHolidays(action.payload).subscribe((result) => {
            let dates: Date[];
            if (result.holidays) {
              dates = [];
              result.holidays.forEach((date) => {
                if (date.date && date.date.iso) {
                  dates.push(new Date(moment(date.date.iso).toDate()));
                }
              });
            }
            this.holidaysStore.dispatch(new LoadHolidaysCompleteAction(dates));
          });
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private store: Store<OrderBuilderState>,
    private holidaysStore: Store<HolidaysState>,
    private holidaysService: HolidaysService,
  ) {}
}
